import clsx from "clsx";
import { forwardRef } from "react";

import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { LinkButton, LinkButtonProps } from "mds/components/buttons/LinkButton";
import { AddPlusIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import { selectIsEditModeEnabled } from "store/selectors";

type AddReference =
  | "page"
  | "block"
  | "activity"
  | "topic"
  | "assignment"
  | "section_description"
  | "course_resource"
  | "ingestion"
  | "instructor_workspace"
  | "outcome"
  | "outcome_subgroup"
  | "outcome_group"
  | "outcome_description"
  | "page_group";

export type HideUnlessEditModeButtonProps = Omit<LinkButtonProps, "size"> & {
  reference: AddReference;
  isDisabled?: boolean;
};

export const HideUnlessEditModeButton = forwardRef<
  HTMLButtonElement,
  HideUnlessEditModeButtonProps
>(function HideUnlessEditModeButtonInternal(
  { onClick, reference, className, eventName, eventProps, isDisabled, ...rest },
  ref,
) {
  const isEditModeEnabled = useAppSelector(selectIsEditModeEnabled);

  if (!isEditModeEnabled) {
    return null;
  }

  const buttonTitle = t(`common.add.${reference}`);

  return (
    <LinkButton
      className={clsx("mx-[10px] h-[34px]", className)}
      disabled={isDisabled}
      eventName={eventName}
      eventProps={eventProps}
      ref={ref}
      size="s"
      title={buttonTitle}
      onClick={onClick}
      {...rest}
    >
      <IconText iconStart={<AddPlusIcon />} text={buttonTitle} />
    </LinkButton>
  );
});
